import { ArticleContentItemRenderer, WordpressReleaseNote } from "@ais-ui/utils";
import { v4 as uuidv4 } from 'uuid';

interface ReleaseNotesContentProps {
    releaseNotes: WordpressReleaseNote;
  }

export const ReleaseNotesContent = ({ releaseNotes }: ReleaseNotesContentProps) => {
  return (
    releaseNotes.acf.marinepulse_content &&
    releaseNotes.acf.marinepulse_content.map((articleContentItem) => (
      <ArticleContentItemRenderer
        key={uuidv4()}
        articleContentItem={articleContentItem}
      ></ArticleContentItemRenderer>
    ))
  ) 
}